import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const empty = { current_password: "", new_password: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (form.new_password !== form.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password changed successfully");
      setForm(empty);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="rounded-none bg-graphite border-line">
        <DialogHeader><DialogTitle className="font-heading uppercase tracking-tight text-white">Change Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2" data-testid="change-password-form">
          {[["current_password", "Current Password"], ["new_password", "New Password (min 6 chars)"], ["confirm", "Confirm New Password"]].map(([k, label]) => (
            <div key={k}>
              <label className="text-xs uppercase tracking-[0.15em] text-silver block mb-1.5">{label} *</label>
              <Input required type="password" value={form[k]} onChange={set(k)} data-testid={`cpw-${k}-input`} className="rounded-none bg-carbon border-line h-10" />
            </div>
          ))}
          <Button type="submit" disabled={busy} data-testid="cpw-submit-btn" className="w-full rounded-none bg-ember hover:bg-[#e64a19] text-white uppercase tracking-wider font-bold h-11">
            {busy ? "Saving…" : "Update Password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
